import Axios from "axios";
import {config} from "@/config";

Axios.defaults.baseURL = config.apiUrl;
// Axios.defaults.headers.get['Auth-Token'] = '123';
Axios.defaults.headers.common['Content-Type'] = 'application/json';

export default {
    namespaced: true,
    state: {
        goods: [
        ],
        currentSort:'id',
        currentSortDir:'asc',
        pageSize:26,
        currentPage:1,
        countRow: 0,

        filterData: {},
        rangeFilterData: {},

        siteFilter: false,
        groupFilter: false,
        nameFilter: false,

        idFilter: false,

        idToFilter: false,
        fieldsList: [],
        fieldsListFull: [],

        singleChangeList: {},
        globalChangeList: {},
        changeLog: [],
    },
    getters: {
        SINGLE_CHANGE_LIST: state => {
            return state.singleChangeList;
        },
        GLOBAL_CHANGE_LIST: state => {
            return state.globalChangeList;
        },
        CHANGE_LOG: state => {
            return state.changeLog;
        },
        FIELDS_LIST: state => {
            return state.fieldsList;
        },
        FIELDS_LIST_FULL: state => {
            return state.fieldsListFull;
        },
        GOODS_LIST: state => {
            return state.goods;
        },
        FILTER_DATA: state => {
            return state.filterData;
        },
        RANGE_FILTER_DATA: state => {
            return state.rangeFilterData;
        },
        CURRENT_SORT: state => {
            return state.currentSort;
        },
        COUNT_ROW: state => {
            return state.countRow;
        },
        ID_FILTER: state => {
            return state.idFilter;
        },
        NAME_FILTER: state => {
            return state.nameFilter;
        },
        CURRENT_SORT_DIR: state => {
            return state.currentSortDir;
        },
        PAGE_SIZE: state => {
            return state.pageSize;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        SITE_FILTER: state => {
            return state.siteFilter;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.countRow/state.pageSize);
        },
        REQUEST_PARAMS: (state) => {
            return {
                'page': state.currentPage,
                'pageSize': state.pageSize <= 0 ? 1 : state.pageSize,
                'filters': JSON.stringify(state.filterData),
                'rangeFilter': JSON.stringify(state.rangeFilterData),
                'sort': state.currentSort,
                'sortDir': state.currentSortDir
            }
        },
    },
    mutations: {
        GLOBAL_CHANGE_LIST: (state, payload) => {
            return state.globalChangeList = payload;
        },
        CHANGE_LOG: (state, payload) => {
            return state.changeLog = payload;
        },
        SINGLE_CHANGE_LIST: (state, payload) => {
            return state.singleChangeList = payload;
        },
        CURRENT_SORT: (state, payload) => {
            return state.currentSort = payload;
        },
        CURRENT_SORT_DIR: (state, payload) => {
            return state.currentSortDir = payload;
        },
        FIELDS_LIST_FULL: (state, payload) => {
            return state.fieldsListFull = payload;
        },
        FIELDS_LIST: (state, payload) => {
            // add column for checkbox
            let buf = [
                {sortable: false, key: "edit", label: ""},
                {sortable: false, key: "checkbox", label: ""}
            ]
            for (let key in payload) {
                buf.push(payload[key])
            }

            return state.fieldsList = buf;
        },
        FILTER_DATA: (state, payload) => {
            return state.filterData = payload;
        },
        RANGE_FILTER_DATA: (state, payload) => {
            return state.rangeFilterData = payload;
        },
        SET_GOODS: (state, payload) => {
            // add column for checkbox
            for (let key in payload) {
                payload[key]['checkbox'] = false
            }

            return state.goods = payload;
        },
        SET_COUNT_ROW: (state, payload) => {
            return state.countRow = payload;
        },
        PAGE_SIZE: (state, payload) => {
            return state.pageSize = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        GOODS_LIST: (state, payload) => {
            return state.goods = payload;
        },
    },
    actions: {
        GET_ALL: async ({commit, getters}, payload) => {
            let urlParams = payload.th.createParamsUrl(getters.REQUEST_PARAMS);

            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/goods-selected' + urlParams,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('SET_GOODS', responseData.data.list);
                    commit('SET_COUNT_ROW', responseData.data.count);
                    commit('FIELDS_LIST', responseData.data.fieldsList);
                    commit('FIELDS_LIST_FULL', responseData.data.fieldsListFull);
                    payload.th.initValue()
                    payload.th.$nextTick(() => {
                        payload.th.recountSize
                        payload.th.markRow()
                    })
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
        DELETE: async ({getters}, payload) => {
            let params = getters.REQUEST_PARAMS;

            params.ids = payload.ids
            params.exceptionIds = payload.exceptionIds
            params.force = payload.force
            params.isAllSelected = payload.isAllSelected

            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-delete',
                th: payload.th,
                parameter: params,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    if (responseData.message === 'FK_F52993984584665A') {
                        payload.th.$bvModal.show('confirmationDeletionForce')
                    } else {
                        payload.th.GET_ALL({th: payload.th})
                        payload.th.totalCheckBox = false
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
        SAVE: async ({state, getters,commit}, payload) => {
            payload.th.showOverlay = true;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-edit',
                th: payload.th,
                parameter: {
                    singleChangeList: state.singleChangeList,
                    globalChangeList: state.globalChangeList,
                    selectParams: getters.REQUEST_PARAMS,
                    selectedRow: payload.th.getSelectedRow,
                    exceptionIds: payload.exceptionIds,
                    isAllSelected: payload.isAllSelected
                },
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    commit('SET_GOODS', responseData.data.list);
                    commit('SET_COUNT_ROW', responseData.data.count);
                    commit('FIELDS_LIST', responseData.data.fieldsList);
                    commit('FIELDS_LIST_FULL', responseData.data.fieldsListFull);
                    payload.th.changed = responseData.data.changed
                    payload.th.initValue()
                    // reset change data
                    payload.th.resetChange(true)
                    payload.th.$nextTick(() => {
                        payload.th.markRow()
                    })
                },
                getResponse: () => {
                    payload.th.showOverlay = false;
                },
            });
        },
        SELECTED_SAVE: async ({state, dispatch}, payload) => {
            console.log(state.pageSize)
            payload.th.showOverlay = true
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/goods-selected-fields',
                th: payload.th,
                parameter: {
                    fields: payload.fields,
                },
                showSuccessMessage: true,
                getSuccessResponse: (responseData) => {
                    console.log(responseData)
                    dispatch('GET_ALL', {th: payload.th})
                },
                getResponse: () => {
                    payload.th.showOverlay = false
                },
            });
        }
    }
}